import { useNavigate } from "react-router-dom";
import { Check, AlertTriangle, ArrowRight } from "lucide-react";

const EL = { meets: ["Eligible on your answers", "text-teal-700"], further_info: ["Eligibility needs confirming", "text-amber-700"], does_not_meet: ["Not eligible as entered", "text-red-700"] };

export default function StageTracker({ app, setTab }) {
  const navigate = useNavigate();
  const st = app.stages;
  const go = (tab) => (tab === "project" ? navigate(`/app/projects/${app.project_id}`) : setTab(tab));
  const el = EL[st.readiness.eligible];
  return (
    <section className="card p-5" data-testid="stage-tracker">
      <ol className="grid grid-cols-5 gap-1.5 sm:gap-2" aria-label="Application stages">
        {st.items.map((s, i) => {
          const cur = s.key === st.current;
          return (
            <li key={s.key}>
              <button onClick={() => go(s.tab)} title={s.title} data-testid={`stage-${s.key}-${s.done ? "done" : cur ? "current" : "todo"}`} className={`flex w-full flex-col items-center gap-1 rounded-xl border p-2 text-center transition-colors sm:flex-row sm:items-start sm:gap-2 sm:p-3 sm:text-left ${cur ? "border-[#1F8A8B] bg-teal-50" : "border-slate-200 hover:bg-slate-50"}`}>
                <span className={`grid h-6 w-6 shrink-0 place-items-center rounded-full text-[11px] font-bold ${s.done ? "bg-[#1F8A8B] text-white" : s.blocked ? "bg-red-100 text-red-700" : "border border-slate-300 text-slate-500"}`}>{s.done ? <Check className="h-3.5 w-3.5" /> : s.blocked ? <AlertTriangle className="h-3.5 w-3.5" /> : i + 1}</span>
                <span className="hidden text-xs font-semibold text-[#0B192C] sm:inline">{s.title}</span>
              </button>
            </li>
          );
        })}
      </ol>
      <p className="mt-2 text-xs font-semibold text-[#0B192C] sm:hidden">Stage {st.items.findIndex((s) => s.key === st.current) + 1} of 5: {st.items.find((s) => s.key === st.current).title}</p>
      <div className="mt-4 flex flex-col gap-3 rounded-xl bg-slate-50 p-4 sm:flex-row sm:items-center sm:justify-between">
        <div><p className="caption">Next action</p><p className="mt-1 text-sm text-slate-800" data-testid="stage-next-action">{st.next_action}</p></div>
        <button onClick={() => go(st.next_tab)} data-testid="stage-next-button" className="btn-teal btn-sm shrink-0">Go to it <ArrowRight className="h-4 w-4" /></button>
      </div>
      <div className="mt-3 flex flex-wrap gap-x-5 gap-y-1 text-xs" data-testid="stage-readiness">
        <span className={st.readiness.complete ? "text-teal-700" : "text-slate-500"}>{st.readiness.complete ? "Application complete" : "Application not complete yet"}</span>
        {el && <span className={el[1]}>{el[0]}</span>}
        <span className="text-slate-500">{st.readiness.note}</span>
      </div>
    </section>
  );
}
